import * as actionTypes from "./action-types";

export const toggleMenu = () => {
  return {
    type: actionTypes.TOGGLE_MENU,
  };
};
